// 角色相关常量与辅助函数，方便在不同模块保持一致
export const ROLE_IDS = {
  PLATFORM_SUPER_ADMIN: 1,
  MERCHANT_SUPER_ADMIN: 2,
  BOSS: 3,
  STAFF: 4,
  TAKEOUT_UNIT: 5,
};

const TAKEOUT_ROLE_NAMES = ["三方运营", "三方运营"];

export const isTakeoutRoleId = (roleId) => roleId === ROLE_IDS.TAKEOUT_UNIT;

export const isTakeoutRoleName = (roleName = "") =>
  !!roleName && TAKEOUT_ROLE_NAMES.includes(roleName);

export const isTakeoutRole = ({ roleId, roleName } = {}) =>
  isTakeoutRoleId(roleId) || isTakeoutRoleName(roleName);



// WEBPACK FOOTER //
// ./src/constants/roles.js